// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V_Xn","right":"styles_right__1ovij"};